const ratingData = 'ratingData'
const visitorData = 'visitorData'

export default {
    clearData() {
        localStorage.removeItem(ratingData)
        localStorage.removeItem(visitorData)
    },
    saveData(data) {
        var datax = localStorage.getItem(ratingData) ? JSON.parse(localStorage.getItem(ratingData)) : [];
        if(datax){
            datax.forEach( (element,index) => {
                if(element.is_facility==1 && element.facility_id == data.facility_id){
                    datax.splice(index, 1);
                }
                if(element.is_facility==0 && element.npp == data.npp){
                    datax.splice(index, 1);
                }
            });
        }
        datax.push(data)
        return localStorage.setItem(ratingData, JSON.stringify(datax))
    },
    get() {
        // localStorage.removeItem(ratingData)
        var datax = JSON.parse(localStorage.getItem(ratingData));
        console.log(datax)
        return datax
    },
    saveVisitor(data) {
        // console.log('save')
        // console.log(data)
        // console.log(JSON.stringify(data))
        return localStorage.setItem(visitorData, JSON.stringify(data))
    },
    getVisitor() {
        // localStorage.removeItem(visitorData)
        var datax = JSON.parse(localStorage.getItem(visitorData));
        return datax
    }
}